import { render } from "./Cursor.vue?vue&type=template&id=faa14c36"
import script from "./Cursor.vue?vue&type=script&lang=js"
export * from "./Cursor.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3987420887/src/bt-website-2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__